import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBatteryFull,
  faBatteryQuarter,
  faBatteryHalf
} from "@fortawesome/free-solid-svg-icons";

const getScooterBatteryIcon = (condition) => {
  let className = "";
  let icon = null;
  // eslint-disable-next-line no-restricted-globals
  if (condition && !isNaN(parseFloat(condition.percent))) {
    const { percent } = condition;
    if (percent > 70) {
      className = "text-success";
      icon = faBatteryFull;
    } else if (percent < 20) {
      className = "text-danger";
      icon = faBatteryQuarter;
    } else {
      className = "text-primary";
      icon = faBatteryHalf;
    }

    if (icon) {
      return (
        <FontAwesomeIcon
          icon={icon}
          className={className}
        />
      );
    }
  }
  return false;
};

export default getScooterBatteryIcon;



// WEBPACK FOOTER //
// ./src/helpers/scooter/get-scooter-battery-icon.js